
import React from 'react';
import { cn } from '@/lib/utils';
import { CheckIcon } from 'lucide-react';

export interface PhaseProps {
  title: string;
  description: string;
  number: number;
  isActive?: boolean;
  isSelected?: boolean;
  isCompleted?: boolean;
  className?: string;
  onClick?: () => void;
}

export const PhaseCard = ({
  title,
  description,
  number,
  isActive = false,
  isSelected = false,
  isCompleted = false,
  className,
  onClick,
}: PhaseProps) => {
  return (
    <div
      className={cn(
        "group relative rounded-lg border backdrop-blur-sm p-4 transition-all duration-300",
        "hover:border-primary/70 hover:shadow-md hover:bg-card/60 cursor-pointer",
        isActive 
          ? "border-primary/50 bg-card/40 shadow-md" 
          : "border-border/30 bg-card/20",
        isSelected 
          ? "border-primary bg-card/70 shadow-lg ring-1 ring-primary/30" 
          : "",
        isCompleted ? "border-green-500/30 hover:border-green-500/50" : "",
        className
      )}
      onClick={onClick}
    >
      <div className="absolute -inset-0.5 bg-gradient-to-r from-primary/20 to-accent/20 opacity-0 group-hover:opacity-100 rounded-lg blur transition-opacity duration-300" />
      <div className="relative flex items-start gap-3">
        <div className="flex flex-col items-center pt-1">
          <div className={cn(
            "flex h-6 w-6 items-center justify-center rounded-full text-xs font-medium",
            isActive ? "bg-primary text-white" : "bg-muted text-muted-foreground",
            isSelected ? "bg-primary text-white ring-2 ring-primary/20" : "",
            isCompleted ? "bg-green-500 text-white" : ""
          )}>
            {isCompleted ? <CheckIcon className="w-3 h-3" /> : number}
          </div>
          <div className="w-px h-full bg-gradient-to-b from-primary/50 to-transparent" />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <h3 className={cn(
              "text-sm font-semibold",
              isActive ? "text-primary" : "text-foreground/90",
              isSelected ? "text-primary" : "",
              isCompleted ? "text-green-500/90" : ""
            )}>
              {title}
            </h3>
            {isActive && (
              <span className="text-[10px] text-primary/70 font-medium bg-primary/10 px-2 py-0.5 rounded-full">
                Current Phase
              </span>
            )}
          </div>
          <p className="text-xs text-muted-foreground leading-relaxed mt-1">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};
